// extracted by mini-css-extract-plugin
export default {"dropdownBox":"style_dropdownBox__W1DBe","box":"style_box__Gmd67","active":"style_active__DjSeR","title":"style_title__ts0fn","item":"style_item__CzKot"};